import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=3ad53ef5&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=3ad53ef5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad53ef5",
  null
  
)

export default component.exports